// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-item__separator___3tEqn {\n  cursor: default;\n\n}\n.media-item__separator___3tEqn:hover{\n  opacity: 0.5;\n}", ""]);
// Exports
exports.locals = {
	"separator": "media-item__separator___3tEqn"
};
module.exports = exports;
